import "./TopHeader.scss";
import "./TopHeaderSellect.css";
import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faFacebook,
  faInstagram,
  faTelegramPlane,
  faYoutube,
  faLinkedin
} from "@fortawesome/free-brands-svg-icons";
// import { Link } from "react-router-dom";
import i18n from "../../i18n";
function TopHeader() {
  const defaultLang = localStorage.getItem("lang") || "uz";
  const [lang, setLang] = useState(defaultLang);

  const handleChange = (event) => {
    setLang(event.target.value);
    localStorage.setItem("lang", event.target.value);
    i18n.changeLanguage(event.target.value);
  };
  const map = [
    { link: "https://www.linkedin.com/in/robiya-tukhtayeva-5a1676242/", id: 1, class: "facebook", icon: faLinkedin },
    { link: "https://t.me/CoderGirl05", id: 2, class: "tele", icon: faTelegramPlane },
    { link: "https://www.instagram.com/", id: 3, class: "insta", icon: faInstagram },
    { link: "https://www.youtube.com/channel/UCFTCGmGD7bCidQ8vffla01w", id: 4, class: "youtube", icon: faYoutube },
  ];
  const map2 = map.map((a) => (
    <li key={a.id} className={a.class}>
      <a href={a.link}>
        <FontAwesomeIcon icon={a.icon}></FontAwesomeIcon>{" "}
      </a>
    </li>
  ));
  return (
    <div className="TopHeader">
      <div className="container">
        <div className="wrapper">
          <div className="left_box">
           
            <div className="call_me">
              {/* <img src={img1}/> */}
            </div>
          </div>
          <div className="right_box">
            <div className="socials">
              <ul>
                <li className="facebook">
                  <div className="select">
                    <select name="lang" value={lang} onChange={handleChange}>
                      <option value="uz">UZ</option>
                      <option value="ru">RU</option>
                    </select>
                  </div>
                </li>
                {map2}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TopHeader;
